import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getPricingSettings = createSelector(property('pricing'), identity);

export const getData = createSelector(getPricingSettings, property('data'));
export const isLoaded = createSelector(
  getPricingSettings,
  property('isLoaded')
);
export const getSelectedLanguage = createSelector(
  getPricingSettings,
  property('lang')
);
export const getError = createSelector(getPricingSettings, property('error'));



// WEBPACK FOOTER //
// ./src/modules/Pricing/selectors/index.js